import React, { useState } from 'react';
import axiosInstance from '../index';

function Login({ onLogin, isOnline }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isOnline) {
      setError('Cannot log in while offline');
      return;
    }
    try {
      const res = await axiosInstance.post('/api/login',
        { username, password },
        { withCredentials: true }
      );
      onLogin();
    } catch (err) {
      setError(err.response?.data?.msg || err.message || 'Login failed');
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <h2>Audio Bible & Tracker Login</h2>
        {error && <div className="error">{error}</div>}
        {!isOnline && (
          <div className="offline-notice">
            You are currently offline. Login will be available when you reconnect.
          </div>
        )}
        <div className="input-group">
          <label htmlFor="username">Username</label>
          <input
            id="username"
            type="text"
            placeholder="Enter your username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoCapitalize="off"
            autoComplete="username"
          />
        </div>
        <div className="input-group">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </div>
        <button type="submit" disabled={!isOnline}>Login</button>
      </form>
    </div>
  );
}

export default Login;